/* eslint-disable import/no-default-export */
import FeatureSet from './feature-set';

// eslint-disable-next-line no-restricted-imports
import {
  MemberFeature,
  MemberFeatureSet,
  ProductInterval,
  ProductName,
  ProductShortName,
  ProductSpecMap,
} from 'types';

const individualFeatures: MemberFeatureSet = new Set([
  MemberFeature.AdditionalStickers,
  MemberFeature.CustomStickers,
  MemberFeature.AdditionalBoardBackgrounds,
  MemberFeature.CustomBoardBackgrounds,
  MemberFeature.LargeAttachments,
  MemberFeature.CustomEmoji,
  MemberFeature.SavedSearches,
]);

const trelloGoldFeatures: MemberFeatureSet = new Set([
  ...individualFeatures,
  MemberFeature.Crown,
  MemberFeature.ReadSecrets,
  MemberFeature.ThreePlugins,
]);

const trelloGoldFromBCFeatures: MemberFeatureSet = new Set([
  ...individualFeatures,
  MemberFeature.InfinitePlugins,
]);

export const products: ProductSpecMap = new Map([
  [
    10,
    {
      shortName: ProductShortName.TrelloGoldFromBC,
      name: ProductName.TrelloGoldFromBC,
      features: trelloGoldFromBCFeatures,
    },
  ],
  [
    37,
    {
      shortName: ProductShortName.TrelloGoldMonthly,
      name: ProductName.TrelloGoldMonthly,
      interval: ProductInterval.Monthly,
      price: 5,
      features: trelloGoldFeatures,
      yearlyEquivalent: 38,
    },
  ],
  [
    38,
    {
      shortName: ProductShortName.TrelloGoldYearly,
      name: ProductName.TrelloGoldYearly,
      interval: ProductInterval.Yearly,
      price: 45,
      features: trelloGoldFeatures,
    },
  ],
]);

class MemberFeatures extends FeatureSet {
  currentProducts = {
    monthly: 'trelloGoldMonthly',
    yearly: 'trelloGoldYearly',
  };

  currentPriceObjectForModel = () => {
    const monthlyProduct = this.currentProducts.monthly;
    const yearlyProduct = this.currentProducts.yearly;

    const monthlyProductPrice = this.getPrice(monthlyProduct);
    const yearlyProductPrice = this.getPrice(yearlyProduct);

    return {
      monthly: {
        productNumber: this.getProductNumber(monthlyProduct),
        price: monthlyProductPrice,
        monthlyPrice: monthlyProductPrice,
      },
      yearly: {
        productNumber: this.getProductNumber(yearlyProduct),
        price: this.getPrice(yearlyProduct),
        monthlyPrice: yearlyProductPrice && yearlyProductPrice / 12,
        savePercent: this.getYearlyDiscountPercent(
          yearlyProduct,
          monthlyProduct,
        ),
      },
      billingStrategy: {
        flatRate: true,
      },
    };
  };

  constructor(memberProducts: ProductSpecMap) {
    super(memberProducts);
  }
}

export default new MemberFeatures(products);



// WEBPACK FOOTER //
// ./app/common/data/member-features.ts